import {Trans} from "../../utils/i18n";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import React, { useState } from "react";
import styled, {css} from "styled-components";
import StatusIcon from "./StatusIcon";
import { Button, IconButton } from "@material-ui/core";
import { ExpandLess, ExpandMore } from "@material-ui/icons";

const StatusCard = styled.div`
    transition: background-color .2s,color .2s;
    border: 2px solid ${props => props.theme.gray};
    border-radius: 5px;
    width: 100%;
    margin: 20px 0;
    text-align: left;
    position: relative;

    ${props => props.status === 'failed' && css`
      border-color: red;
    `}

    ${props => props.status === 'success' && css`
        border-color: #46BA07;
    `}

    ${props => props.status === 'waiting' && css`
      color: #555;
    `}
`;

const IconWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const CardInner = styled.div`
    flex: 1 1 0%;
`;

const OpenInTrackTrace = styled.a`
    margin-left: 5px;
    text-decoration: none;
    color: ${props => props.theme.text};
    display: inline-flex;
    align-items: end;
`;

const OpenInTrackTraceIcon = styled.svg`
    height: 16px;
    margin-left: 5px;
`;

export function StatusCardComponent({item, displayArrow, translate,}) {
    const [isExpanded, setExpanded] = useState(false);

    let status = 'waiting';

    if (item.datetime && item.exception) {
        status = 'failed';
    } else if (item.datetime) {
        status = 'success';
    }

    let hasDetails = false;

    if (item.grade ||
        item.instruction ||
        item.comment ||
        item.estimatedDate ||
        item.carrier ||
        item.trackingnumber ||
        item.returnCarrier ||
        item.returnTrackingnumber ||
        item.pickupNumber ||
        item.pickupTimeslot
    ) {
        hasDetails = true;
    }

    return (
        <div className={'flex flex-col items-center justify-center'} key={item.key}>
            <StatusCard status={status}>
                <div style={{opacity: status=='waiting' ? 0.6 : 1.0}} className={'grid grid-cols-[50px_auto_30px] lg:grid-cols-[100px_auto_30px] gap-4 auto-cols-min w-full p-5'}>
                    <IconWrapper>
                        <StatusIcon iconKey={item.key} icon={item.icon}/>
                    </IconWrapper>
                    <CardInner>
                        <div className={'flex items-center justify-between w-full'}>
                            <div className={'text-gray-500'}>{item.datetime}</div>
                        </div>

                        <h2 class={'text-xl lg:text-2xl mt-0 mb-0'}>{item.name}</h2>

                        <div className={'flex items-center w-full'}>
                            {item.exception ? item.exception : item.datetime ? item.description : null}
                        </div>

                        {
                            isExpanded &&
                            <div>
                                {
                                    item.grade && <span><Trans i18nKey="statusFlow.grade">Grade</Trans>: {item.grade}<br/></span>
                                }
                                {
                                    item.instruction &&
                                    <span><Trans i18nKey="statusFlow.instruction">Instruction</Trans>: {item.instruction}</span>
                                }
                                {
                                    item.comment && <span>{item.comment}<br/></span>
                                }
                                {
                                    item.estimatedDate && <span><Trans
                                        i18nKey="statusFlow.estimatedDate">Estimated date</Trans>: {item.estimatedDate}<br/></span>
                                }
                                {
                                    item.carrier &&
                                    <span><Trans i18nKey="statusFlow.carrier">Carrier</Trans>: {item.carrier}<br/></span>
                                }
                                {
                                    item.trackingnumber && !item.carrierTrackingLink && <span><Trans
                                        i18nKey="statusFlow.trackingNumber">Tracking number</Trans>: {item.trackingnumber}<br/><br/></span>
                                }
                                {
                                    item.trackingnumber && item.carrierTrackingLink &&
                                    <span><Trans i18nKey="statusFlow.trackingNumber">Tracking number</Trans>:
                                        <OpenInTrackTrace
                                            href={item.carrierTrackingLink}
                                            target={'_blank'}>
                                            {item.trackingnumber}
                                            <OpenInTrackTraceIcon aria-hidden="true" focusable="false" data-prefix="fas"
                                                                data-icon="external-link-alt" role="img"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                viewBox="0 0 512 512"
                                                                className="svg-inline--fa fa-external-link-alt fa-w-16 fa-3x">
                                                    <path fill="currentColor"
                                                        d="M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z"
                                                        className=""></path>
                                            </OpenInTrackTraceIcon>
                                        </OpenInTrackTrace>
                                    <br/><br/></span>
                                }
                                {
                                    item.returnCarrier && <span><Trans
                                        i18nKey="statusFlow.returnCarrier">Return carrier</Trans>: {item.returnCarrier}<br/></span>
                                }
                                {
                                    item.returnTrackingnumber && !item.returnCarrierTrackingLink && <span><Trans
                                        i18nKey="statusFlow.returnTrackingNumber">Return tracking number</Trans>: {item.returnTrackingnumber}<br/></span>
                                }
                                {
                                    item.returnTrackingnumber && item.returnCarrierTrackingLink &&
                                    <span><Trans i18nKey="statusFlow.returnTrackingNumber">Return tracking number</Trans>:
                                        <OpenInTrackTrace
                                            href={item.returnCarrierTrackingLink}
                                            target={'_blank'}>
                                            {item.returnTrackingnumber}
                                            <OpenInTrackTraceIcon aria-hidden="true" focusable="false" data-prefix="fas"
                                                                data-icon="external-link-alt" role="img"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                viewBox="0 0 512 512"
                                                                className="svg-inline--fa fa-external-link-alt fa-w-16 fa-3x">
                                                    <path fill="currentColor"
                                                        d="M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z"
                                                        className=""></path>
                                            </OpenInTrackTraceIcon>
                                        </OpenInTrackTrace>
                                    <br/><br/></span>
                                }
                                {
                                    item.pickupNumber && <span><Trans
                                        i18nKey="statusFlow.pickupNumber">Pickup confirmation number</Trans>: {item.pickupNumber}<br/></span>
                                }
                                {
                                    item.pickupTimeslot && <span><Trans i18nKey="statusFlow.pickupTimeslot">Estimated pickup timeslot</Trans>: {item.pickupTimeslot}<br/></span>
                                }
                            </div>
                        }

                    </CardInner>
                    <div className={'flex flex-col items-end'}>
                        {
                            status === 'success' &&
                            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="13" cy="13" r="12.5" fill="#46BA07" stroke="white"/>
                                <path d="M5.67285 14.6546L9.69103 18.6727L20.3274 8.03638" stroke="white" strokeWidth="3"/>
                            </svg>
                        }
                        {
                            status === 'failed' &&
                            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="13" cy="13" r="12.5" fill="#FF0000" stroke="white"/>
                                <path d="M7 7L19 19M19 7L7 19" stroke="white" strokeWidth="3"/>
                            </svg>
                        }
                    </div>
                </div>
                {
                    hasDetails &&
                    <div className={'flex justify-center w-full border-t border-gray-400 p-1'}>
                        <Button className={'!text-sm'} size="small" onClick={()=>setExpanded(pref=>!pref)}>
                            {
                                isExpanded === false &&
                                <>
                                <Trans i18nKey="common.show_more">show more</Trans>
                                <ExpandMore />
                                </>
                            }
                            {
                                isExpanded === true &&
                                <>
                                <Trans i18nKey="common.show_less">show less</Trans>
                                <ExpandLess />
                                </>
                            }

                        </Button>
                    </div>
                }
            </StatusCard>
            {
                displayArrow && <ArrowDownwardIcon style={{
                    transform: translate ? 'translate(-2.65rem)' : undefined,
                }}/>
            }
        </div>
    );
}
